import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className,
  href,
  fullWidth = false,
  onClick,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-black uppercase tracking-tight transition-all duration-200 transform hover:scale-105 active:scale-95 rounded-xl py-2.5 px-4 text-sm md:text-base leading-none shadow-[0px_10px_25px_rgba(212,168,67,0.4)] bg-[#D4A843] hover:bg-[#E0B84E] text-[#FFFFFF] border-b-4 border-[#B8922E] hover:brightness-115 hover:glow-gold';
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    if (onClick) onClick(e as any);
  };
  if (href) {
    return <a href={href} className={`${baseStyles} ${widthClass} ${className || ''}`} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-33">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseStyles} ${widthClass} ${className || ''}`} {...props} data-id="element-34">
      {children}
    </button>;
}